import Axios, { AxiosRequestConfig } from 'axios';
import { Api, MAX_RETRIES } from 'utils/constants';
import { getApiDomain } from 'utils/url';
import { Availability } from 'interfaces/common';
import { logger } from 'utils';

const axiosOpts: AxiosRequestConfig = {
  baseURL: getApiDomain()
};

const isOverride = () => (process.env.REACT_APP_KILLSWITCH || '').trim().toUpperCase() === 'TRUE';

export async function checkAvailability(
  retryCount = 1
): Promise<{ status: Availability; startTime?: string }> {
  if (isOverride()) {
    return {
      status: 'TOO_LATE'
    };
  }
  try {
    const result = await Axios.get(Api.CheckAvailability, axiosOpts);
    const success = result.status >= 200 && result.status < 300;

    if (!success && retryCount < MAX_RETRIES) {
      return await checkAvailability(retryCount + 1);
    }
    // retry exceeded, or was failure
    return {
      status: 'SUCCESS'
    };
  } catch (e: any) {
    if (e.response && typeof e.response.status === 'number') {
      if (e.response.status === 412) {
        return {
          status: 'TOO_EARLY',
          startTime: e.response.data?.message
        };
      } else if (e.response.status === 422) {
        return {
          status: 'TOO_LATE'
        };
      } else if (retryCount < MAX_RETRIES) {
        return await checkAvailability(retryCount + 1);
      }
      logger.error('Check Availability Error', e);
      return {
        status: 'TECHNICAL_ERROR'
      };
    } else if (retryCount < MAX_RETRIES) {
      return await checkAvailability(retryCount + 1);
    }

    logger.error('Check Availability Error', e);
    return { status: 'TECHNICAL_ERROR' };
  }
}

export async function submitForm<T>(value: T, retryCount = 1): Promise<Availability> {
  if (isOverride()) {
    return 'TOO_LATE';
  }
  try {
    const result = await Axios.post(Api.SubmitForm, value, axiosOpts);
    const success = result.status >= 200 && result.status < 300;

    if (!success && retryCount < MAX_RETRIES) {
      return await submitForm(value, retryCount + 1);
    }
    logger.info('Travel voucher form request successfully submitted');

    return 'SUCCESS';
  } catch (e: any) {
    if (e.response && typeof e.response.status === 'number') {
      if (e.response.status === 412) {
        return 'TOO_EARLY';
      } else if (e.response.status === 422) {
        return 'TOO_LATE';
      } else if (retryCount < MAX_RETRIES) {
        return await submitForm(value, retryCount + 1);
      }
      // retry exceeded, or was failure
      logger.error('Submit Form Error', e);
      return 'TECHNICAL_ERROR';
    } else if (retryCount < MAX_RETRIES) {
      return await submitForm(value, retryCount + 1);
    }

    logger.error('Submit Form Error', e);
    return 'TECHNICAL_ERROR';
  }
}
